/*
 * Selectors using reselect.
 */
import { createSelector } from 'reselect';
import { NO_PREFERENCE, ROOMS } from 'utils/constants';
import filter from 'lodash/filter';
import { propertySelector } from 'routes/DateSelection/selectors';

const rootSelector = state => state.app.accommodation;

const formSelector = state => state.form.chooseAccommodation;

export const selectedRoomSelector = createSelector(
  rootSelector,
  subState => subState.selectedRoom
);

export const filtersSelector = createSelector(
  rootSelector,
  subState => subState.filters
);

export const roomsSelector = createSelector(
  rootSelector,
  subState => subState.rooms
);

export const roomTypeSelector = createSelector(
  filtersSelector,
  filters => filters.roomType
);

export const filteredRoomsSelector = createSelector(
  roomsSelector,
  filtersSelector,
  propertySelector,
  (rooms, filters, property) =>
    filter(rooms, room => {
      const roomTypeCode = room.roomType.roomTypeCodes.roomTypeCode;
      const roomInfo = ROOMS[property][roomTypeCode];

      const roomTypeFilter =
        filters.roomType && filters.roomType.label !== 'All'
          ? roomInfo.roomType === filters.roomType.value
          : true;
      const smokingFilter =
        filters && filters.smoking && filters.smoking !== NO_PREFERENCE
          ? roomInfo.smoking === filters.smoking
          : true;
      const accessibilityFilter =
        filters && filters.accessible
          ? roomInfo.accessible === filters.accessible
          : true;

      return roomTypeFilter && smokingFilter && accessibilityFilter;
    })
);

// Selector to get the values from the redux-form.
export const accommodationFormSelector = createSelector(
  formSelector,
  subState => subState && subState.values
);

export const shouldRefetchSelector = createSelector(
  rootSelector,
  subState => subState.shouldRefetch
);
